<div class="full-width info-header page-padding"
     [ngStyle]="{'background-color': backgroundWhite ? 'white' : null}"
     [class.bottom-border]="bottomBorder"
     fxLayout="column" [class.full-screen-height]="fullHeight" *ngIf="!banner">
  <span class="mat-caption text-uppercase" fxFlexOffset="30px">{{ section }}</span>
  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="mat-headline-5">{{ title }}</span>
    <div *ngIf="isTabbed && tabs!.length > 1" fxLayoutGap="15px">
      <button (click)="changeSelectedTab(tab)" *ngFor="let tab of tabs" [class.button-tab-active]="isActive(tab)"
              [disabled]="tab.disabled!"
              class="button-tab" mat-flat-button>
        <div class="button-text">{{ tab.name }}</div>
      </button>
    </div>
    <!-- Optional action slot, right-aligned against the title (e.g. a refresh button). -->
    <ng-content select="[header-actions]"></ng-content>
  </div>
  <span class="mat-body-1 header-desc" fxFlexOffset="10px"
        [class.header-desc-full-width]="fullWidthDescription">{{ description }}</span>
</div>

<div class="full-width banner-header" fxLayout="column" fxLayoutAlign="end start" fxLayoutGap="20px"
     [class.full-screen-height]="fullHeight" *ngIf="banner">
  <div class="page-padding full-width" fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
    <span class="mat-headline-5">{{ title }}</span>
    <span class="$body-2">{{ subtitle }}</span>
  </div>
  <mat-divider class="full-width"></mat-divider>
  <span class="mat-body-1 page-padding" style="padding-bottom: 20px">{{ description }}</span>
</div>

